"use strict";

exports.__esModule = true;
exports.default = void 0;
var initialState = {
  isLoading: false,
  hasError: false,
  consumptionDetails: null
};
var _default = initialState;
exports.default = _default;